import React, {useState} from 'react';
import AnimateHeight from 'react-animate-height';

import classNames from 'classnames';

import {Container} from './../container';
import {Icon} from './../icon/icon';
import {Grid, GridColumn} from './../grid';

export interface INotificationProps {
    text: string | JSX.Element;
    type: 'error' | 'info' | 'success';
    className?: string;
    defaultIsOpen?: boolean;
    title?: string;
    isClosable?: boolean;
    hasClickableUrl?: boolean;
}

const Notification = ({
    type = 'error',
    className,
    defaultIsOpen = false,
    title,
    text,
    hasClickableUrl,
    isClosable,
}: INotificationProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>(defaultIsOpen);
    const computedClassName: string = classNames(
        'notification',
        {
            [`notification--type-${type}`]: type,
            'is-open': isOpen,
        },
        className,
    );

    const handleCloseClick = (): void => {
        setIsOpen(false);
    };

    return (
        <Container className={computedClassName}>
            <AnimateHeight duration={200} height={isOpen ? 'auto' : 0} easing="ease-in-out">
                <div className="notification__inner">
                    <Grid align={['middle-xs']} gutter="small">
                        <GridColumn align={['top-xs']} width={['min-xs']}>
                            <Icon className="notification__icon" name="warning" />
                        </GridColumn>
                        <GridColumn width={['max-xs']}>
                            <div className="text">
                                {title && <h4>{title}</h4>}
                                {typeof text === 'string' ? (
                                    hasClickableUrl ? <p dangerouslySetInnerHTML={{__html: text}} /> : <p>{text}</p>
                                ) : text}
                            </div>
                        </GridColumn>
                        {isClosable && <button className="notification__close" onClick={handleCloseClick}>
                            <Icon name="close" />
                        </button>}
                    </Grid>
                </div>
            </AnimateHeight>
        </Container>
    );
};

export default Notification;
